"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.addWatchedNames = addWatchedNames;
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/array/is-array"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/for-each"));
var _addWatchedName = require("../add-watched-name");
function addWatchedNames(inputNames) {
  return function (getState, dispatch) {
    const {
      inputStates
    } = getState();
    if (typeof inputNames === 'string') {
      dispatch((0, _addWatchedName.addWatchedName)(inputNames));
    } else if ((0, _isArray.default)(inputNames)) {
      (0, _forEach.default)(inputNames).call(inputNames, name => {
        dispatch((0, _addWatchedName.addWatchedName)(name));
      });
    } else if (inputNames === undefined) {
      (0, _forEach.default)(inputStates).call(inputStates, (inputState, inputElement) => {
        dispatch((0, _addWatchedName.addWatchedName)(inputElement.name));
      });
    }
  };
}